import { render, staticRenderFns } from "./CustomCheckBoxItem.vue?vue&type=template&id=197aac2b&"
import script from "./CustomCheckBoxItem.vue?vue&type=script&lang=js&"
export * from "./CustomCheckBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomCheckBoxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports